<script setup lang="ts">
const props = defineProps<{
  rounded?: boolean;
}>();

const vertical = inject<"top" | "bottom">("vertical");
const horizontal = inject<"start" | "end">("horizontal");
</script>

<template>
  <button
    :class="[
      'w-10 h-10',
      'transition select-none',
      'bg-black text-white',
      'hover:bg-white hover:text-black',
      'flex items-center justify-center',

      props.rounded
        ? 'rounded-full'
        : [
            'rounded-xl',
            {
              'first:rounded-ss-none':
                vertical === 'top' && horizontal === 'start',
              'first:rounded-se-none':
                vertical === 'top' && horizontal === 'end',
              'last:rounded-es-none':
                vertical === 'bottom' && horizontal === 'start',
              'last:rounded-ee-none':
                vertical === 'bottom' && horizontal === 'end',
            },
          ],
    ]"
  >
    <slot />
  </button>
</template>
